module.exports = __webpack_public_path__ + "src/assets/img/share-wechat-pyq.61f4f182.png";